<template>
  <div class="hidden sm:block w-3/12 lg:w-2/12">
    <!-- Card Moderno -->
    <div class="bg-white rounded-xl shadow-lg overflow-hidden sticky top-24">
      <!-- Links do menu -->
      <nav class="py-2">
        <router-link 
          to="/ranking" 
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-chart-bar w-5 text-green-600"></i>
          <span class="font-medium">Ranking</span>
        </router-link>

        <router-link 
          to="/reports-betting"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-chart-line w-5 text-green-600"></i>
          <span class="font-medium">Ranking Report</span>
        </router-link>

        <router-link 
          to="/current-round"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-calendar-check w-5 text-green-600"></i>
          <span class="font-medium">Rodada Atual</span>
        </router-link>

        <router-link 
          :to="{ name: 'NewBetting', params: {userId: this.getUserId()}}"
          v-bind:class="{'hidden': !hasPermission('UserBolao')}"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-edit w-5 text-green-600"></i>
          <span class="font-medium">Criar Palpite</span>
        </router-link>

        <router-link 
          to="/standings"
          v-bind:class="{'hidden': !hasPermission('UserBolao')}"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-table w-5 flex-shrink-0 text-green-600"></i>
          <span class="font-medium whitespace-nowrap">Classificação Brasileirão</span>
        </router-link>

        <router-link 
          to="/bet-rules"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-book w-5 text-green-600"></i>
          <span class="font-medium">Regras</span>
        </router-link>

        <router-link 
          to="/betting-saved"
          v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500"
          active-class="bg-green-50 text-green-700 border-green-500">
          <i class="fas fa-save w-5 text-green-600"></i>
          <span class="font-medium">Palpites Salvos</span>
        </router-link>

        <!-- Divisor -->
        <div 
          v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
          class="border-t border-gray-200 my-2 mx-4"></div>

        <!-- Atualizar Ranking -->
        <a 
          href="#"
          @click.prevent="updateRanking()"
          v-bind:class="{'hidden': !hasPermission('SuperAdmin')}"
          class="flex items-center gap-3 px-4 py-3 text-sm text-gray-700 hover:bg-green-50 hover:text-green-700 transition-colors duration-150 border-l-4 border-transparent hover:border-green-500">
          <i class="fas fa-sync-alt w-5 text-green-600"></i>
          <span class="font-medium">Atualizar Ranking</span>
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
import jwt_decode from 'jwt-decode';
import { mapActions, mapGetters } from 'vuex';
import { useToast } from "vue-toastification";
import RankingService from '@/services/rankingService';

export default {
  name: 'NavigationBetting',
  setup() {
      const toast = useToast();
      return { toast }
  },
  computed: {
    ...mapGetters('user', {
      userProfile: 'userProfile',
    })
  },
  created() {
    let token = localStorage.getItem('token');
    if (token !== null) {
     try {
        let payload = jwt_decode(token);
        this.userData = payload;
      } catch (err) { console.log(err)}
    }
  },
  methods: {
    getUserId() {
      if (this.userData.length == 0) {
        return false;
      }
      return this.userData._id;
    },
    async auth() {
      await this.login();
      this.$router.push('/');
    },
    async logoff() {
      await this.logout();
      this.$router.push('/login');
    },
    toggleMenu(menu) {
        switch (menu) {
          case 'betting':
            this.showBetting = !this.showBetting
            return;
          case 'betting-mobile':
            this.showBettingMobile = !this.showBettingMobile
            return;
          case 'profile':
            this.showProfile = !this.showProfile;
            return;
          case 'navbar':
            this.showMenu = !this.showMenu;
            return;
          default:
            return;
        }
    },
    hasPermission(permission) {
      if (this.userData.length == 0) {
        return false;
      }
      let { rules } = this.userData;
      return rules.filter(data => {
        return data === permission || data === "SuperAdmin"
      }).length > 0;
    },
    updateRanking() {
      RankingService.updateRanking().then(data => {
        console.log(data.status);
        this.toast.success("Atualizando o ranking.", {
          onClose: () => {
            location.reload()
          }
        });
      }).catch(error => {
        this.toast.error(`Erro ao atualizar: ${error.getMessage()}`);
      })
    },
    ...mapActions('user', {
      login: 'login',
      logout: 'logout'
    })
  },
  data() {
    return {
      showMenu: false,
      showProfile: false,
      showBetting: false,
      showBettingMobile: false,
      userData: ''
    }
  },
}
</script>